<template>
<div>
  <div class="content" id="contentWrap">
    <div class="slider_container">
      <div>
        <img src="../../assets/images/kia-banner_01.png" alt="pure css3 slider" />
      </div>
      <div>
        <img src="../../assets/images/kia-banner_02.png" alt="pure css3 slider" />
      </div>
      <div>
        <img src="../../assets/images/kia-banner_03.png" alt="pure css3 slider" />
      </div>
    </div>
    <div class="clum2left left">
      <div id="login_block">
        <div id="login_title">User</div>
        <div id="login_content">
          <div class="pure-form pure-form-stacked">
            <label for="email" class="login_gray">Email:</label>
            <input id="email" class="login_input" type="email" v-model="email">
            <label for="password" class="login_gray">Password:</label>
            <input id="password" class="login_input" type="password" v-model="passwd">
            <label class="login_reg">
                  <router-link to="/Register" class="link">Register</router-link>
                  &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
                  <router-link to="/Forgetpsw" class="link">Forgot Password?</router-link>
                </label>
            <button class="button-warning pure-button  login_input" @click="clicklogin()">Login</button>
          </div>
        </div>
      </div>
      <div id="update_block">
        <div id="update_content">
          <div class="update_title">Map Updater 3</div>
          <div class="update_img"></div>
          <div>
            <form method="get" action="http://maptool.polnav.com.tw/fixture/Flash/MapUpdater3/mapupdater3_setup.exe">
              <button class="button-warning pure-button login_input">Download</button>
            </form>
          </div>  
        </div>
      </div>
    </div>
    <!-- Left Content -->
    <LoginContent></LoginContent>
  </div>
</div>
</template>
<script>
/*jshint esversion: 6 */
import {
  getDataUrl
} from '../../tools/getUrl.js';
import LoginContent from './LoginContent';
import router from '../../router.js';

export default {
  components: {
    LoginContent
  },
  data: function() {
    return {
      email: '',
      passwd: '',
      todos: [{
        text: 'Add some todos'
      }]
    };
  },
  mounted() {
    // auto login
    if (sessionStorage.getItem('email')) this.$router.replace('/Main/Maps');
  },
  methods: {
    clicklogin: function() {
      var strEmail = this.email.trim(),
        strPasswd = this.passwd.trim(),
        obj = {
          api: 'login',
          email: strEmail,
          passwd: strPasswd
        },
        url = getDataUrl(obj);

      this.$http.get(url).then((response) => {
        // success callback
        var datums = response.data;
        if (datums > 0) {
          if (typeof(Storage) !== 'undefined') {
            // Code for sessionStorage.
            sessionStorage.setItem('accountid', datums);
            sessionStorage.setItem('email', this.email);
            sessionStorage.setItem('psw', this.passwd);

            setTimeout(function() {
              router.replace('/Main/Maps');
            }, 200);
          } else {
            // Sorry! No Web Storage support..
          }
        } else if (datums == -51) {
          alert('Please check your account or password.');
        } else if (datums == -52) {
          alert('Please check your account or password.');
        }
      }, (response) => {
        // error callback
      });
    }
  }
};
</script>
<style scoped>
.button-download {
  width: 196px;
  background: rgb(255, 90, 0);
  /* this is a green */
  color: #FFFFFF;
}


</style>



// WEBPACK FOOTER //
// Login.vue?c7d457a8